<template>
  <div class="bread">
    <div class="tagView">
      <!-- <div class="title_aside"></div> -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path:$route.meta.fullPath }">{{ $route.meta.basic }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path:$route.meta.secondPath }">{{ $route.meta.title }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.meta.firstTitle" :to="{ path:$route.meta.thirdPath }">{{
          $route.meta.firstTitle
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.meta.secondTitle">{{
          $route.meta.secondTitle
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="navMask" v-if="navBarMaskShow" @click="$store.dispatch('routerInfo/setNavBarMask')"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "tagView",
  computed: {
    ...mapState({
      navBarMaskShow: (state) => state.routerInfo.navBarMaskShow,
    }),
  },
  created() {
  },
};
</script>

<style scoped lang="less">
.bread {
  margin-bottom: 15px;
  position: relative;
}
</style>
